import { Hub } from 'aws-amplify';
import store from '../store';

Hub.listen('initialize', () => {
  console.log('IPM dashboard initialized');

  store.dispatch({ type: 'INITIALIZE' });
});